// Reusable "Group by:" dropdown for SettingsPage's grouped lists.
//
// Used by Machines / Vendors / Materials tabs. Each tab passes its own
// option set ("First tag", "Run rate (high → low)", etc.) so the control
// stays generic.

export interface GroupedListControlsProps {
  groupBy: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
}

export function GroupedListControls({
  groupBy,
  options,
  onChange,
}: GroupedListControlsProps) {
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs font-semibold text-text-mute uppercase tracking-wide">
        Group by:
      </label>
      <select
        value={groupBy}
        onChange={(e) => onChange(e.target.value)}
        className="px-2 py-1 border border-line-dark rounded text-sm bg-white focus:outline-none focus:border-orange"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
